/**
 * Lo que el ALMACÉN tiene de cada producto que este negocio importó de Smarty Drop.
 *
 * ⭐ POR QUÉ NO SALE DE `products.stock`. Al importar se copiaba el stock del almacén y no se
 *    volvía a mirar: en producción el revendedor leía «481 disponibles» de algo que el almacén
 *    tenía en 434 (copiado el 26-ago). La publicación del revendedor no es una existencia — no
 *    tiene stock propio (migración 20260922140000) — así que la cantidad se pregunta en el momento
 *    de mostrarla, que es la única forma de que no envejezca.
 *
 * 🪤 Y ES LA MISMA VERDAD QUE USA EL PEDIDO. `fn_drop_previo_de_venta` valida la disponibilidad
 *    contra el stock del almacén desde siempre; esto hace que la lista diga lo mismo que el previo,
 *    en vez de dos números que se contradicen.
 */
import { supabase } from '@/lib/supabase';

export interface StockDelAlmacen {
  /** Cuánto hay HOY en el almacén. */
  stock: number;
  /** Si el almacén lo tiene publicado: despublicado no se puede pedir aunque haya stock. */
  publicado: boolean;
  proveedor: string | null;
}

/**
 * Por `product_id` del revendedor. Vacío si no importó nada — y entonces no cuesta nada más que
 * una consulta que no devuelve filas.
 */
export async function stockDelAlmacen(
  tenantId: string,
  productIds: string[],
): Promise<Record<string, StockDelAlmacen>> {
  if (productIds.length === 0) return {};
  const { data, error } = await supabase.rpc('fn_drop_stock_de_lo_importado', {
    p_tenant: tenantId,
    p_productos: productIds,
  });
  if (error) throw error;
  const filas = (Array.isArray(data) ? data : []) as Array<{
    product_id: string; stock: number | null; publicado: boolean | null; proveedor: string | null;
  }>;
  return Object.fromEntries(filas.map((f) => [
    f.product_id,
    { stock: Number(f.stock ?? 0), publicado: f.publicado !== false, proveedor: f.proveedor ?? null },
  ]));
}
